import { Button, Dropdown, Flex } from "antd";
import styled from "styled-components";

import { Text } from "@/components/Typography";
import breakpoints from "@/constants/breakpoints";

export const Container = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    width: 175px;
    max-width: 175px;
    padding: 2px;
    margin-left: 4px;
    background-color: ${props => props.theme.layouts.mainLayout.header.accountButton.bgColor};
    border-radius: 10px;

    @media ${breakpoints.xs} {
        width: 150px;
    }
`;

export const InfoBox = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
`;

export const CompanyText = styled(Text)`
    overflow: hidden;
    color: ${props => props.theme.layouts.mainLayout.header.accountButton.companyTextColor}; 
    text-overflow: ellipsis;
`;

export const NameText = styled(Text)`
    overflow: hidden;
    color: ${props => props.theme.layouts.mainLayout.header.accountButton.nameTextColor}; 
    text-overflow: ellipsis;
`;

export const RoleText = styled(Text)`
    font-size: 10px !important;
    line-height: 14px !important;
    color: ${props => props.theme.layouts.mainLayout.header.accountButton.statusTextColor};
`;

export const AccountButtonStyled = styled(Button)`
    width: 36px;
    min-width: 36px;
    height: 36px;
    padding: 0;
    color: ${props => props.theme.layouts.mainLayout.header.accountButton.buttonColor};
    border-color: ${props => props.theme.layouts.mainLayout.header.accountButton.buttonBorderColor};
    border-radius: 8px;
    box-shadow: none;
`;

export const DropdownStyled = styled(Dropdown)`
    .ant-dropdown-menu {
        padding: 10px !important;
        border-radius: 100px ;
    }
`;

export const DropdownButtonStyled = styled(Button)`
    width: 100%;
    height: 32px;
    padding: 0;
    text-align: center;
    background:
    ${props => props.theme.layouts.mainLayout.header.accountButton.boxButtonBgColor};
    border: 1px solid ${props => props.theme.layouts.mainLayout.header.accountButton.boxButtonBorderColor};
    border-radius: 6px;
`;

export const UserInfoFlex = styled(Flex)`
    width: 140px;
    padding: 4px 12px;
    text-align: center;
    user-select: none;
`;
